<!--
 * @Author: caizexin caizexin@kjgb.net
 * @Date: 2024-05-21 11:41:28
 * @LastEditors: caizexin caizexin@kjgb.net
 * @LastEditTime: 2025-04-16 18:49:55
 * @FilePath: \vue-hepha-order\src\views\approval\OrderApprovalList.vue
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
-->
<template>
    <div class="approval_container">
        <div class="content_left">
            <div class="content_left_header">
                <a-tabs :active-key="activeKey" @change="tabClick">
                    <a-tab-pane key="1" :title="$t('approval.pendingApproval')"></a-tab-pane>
                    <a-tab-pane key="2" :title="$t('approval.approved')"></a-tab-pane>
                </a-tabs>
                <a-button class="deleteFilters" type="outline" @click="deleteFilters">{{ $t('approval.deleteFilters') }}</a-button>
            </div>
            <Table 
                ref="orderTableRef"
                :table="table"
            >
                <!-- 自定义字段 -->
                <template v-slot:columns="{ props }">
                    <div v-if="props.column.key == 'instance_status'" style="font-size:12px;">
                        <a-tag 
                            v-if="props.record.instance_status != '-'"
                            :color="instanceStatusColor[props.record.instance_status_val]" 
                            :text="props.record.instance_status"
                        >{{ props.record.instance_status }}</a-tag>
                        <div v-else>-</div>
                    </div>
                    <div v-if="props.column.key == 'node_code'" style="font-size:12px;">
                        <a-tag 
                            v-if="props.record.instance_status != '-'"
                            :color="instanceStatusColor[props.record.instance_status_val]" 
                            :text="props.record.instance_status"
                        >{{ props.record.instance_status }}</a-tag>
                        <div v-else>-</div>
                    </div>
                </template>

                <template v-slot:searchFilter="{ props }">
                    <div class="searchFilter">
                        <a-space direction="vertical">
                        <a-input :model-value="props.filterValue[0]" style="width:164px" @input="(value)=>props.setFilterValue([value])" />
                        <div class="searchFilter-footer">
                            <a-button style="margin-right:10px" @click="props.handleFilterReset">{{ $t('base.reset') }}</a-button>
                            <a-button type="primary" @click="props.handleFilterConfirm">{{ $t('base.confirm2') }}</a-button>
                        </div>
                        </a-space>
                    </div>
                </template>

                <!-- 父表格操作 -->
                <template v-slot:tableOperate="{ props }">
                    <!-- <a-button v-permission="'setting.approval.approve'"  type="primary" status="success" size="mini" v-if="getDisabled(props.record.instance_status_val)" @click="handle('approval', props.record)">
                        {{ $t('approval.approve') }}
                    </a-button> -->
                    <a-button v-permission="'setting.approval.detail'"  type="primary" size="mini" @click="handle('detail',props.record)">
                        {{ $t('approval.detail') }}
                    </a-button>
                    <!-- <a-button v-permission="'setting.approval.closeApproval'" type="primary" status="warning" size="mini" v-if="getDisabled(props.record.instance_status_val)" @click="handle('close',props.record)">
                        {{ $t('approval.close') }}
                    </a-button> -->
                </template>
            </Table>
        </div>

        <!-- 审核 -->
        <div class="content_right" v-if="showContentRight">
            <icon-close :size="25" style="cursor:pointer" @click="showContentRight = !showContentRight" />
            <div class="content_right_hd">
                
                <div class="form_title">{{ rowData.customer_name }}</div>
                <div class="footerBtn" v-if="!showContentRightDetail">
                    <a-button  type="primary" size="small" class="adopt" @click="handle('adopt')">{{ $t('approval.adopt') }}</a-button>
                    <a-button type="primary" status="danger"  size="small" @click="handle('refuse')">{{ $t('approval.refuse') }}</a-button>
                </div>
            </div>
            
            <!-- 基础信息 -->
            <div class="baseInfo">
                <div class="baseInfoBlock"> 
                    <div class="block_item">
                        <span class="label">{{ $t('approval.orderNumber') }}</span>
                        <span class="value">{{ rowData.business_order_name }}</span>
                    </div>
                    <div class="block_item">
                        <span class="label">{{ $t('approval.businessOrderAmount') }}</span>
                        <span class="value">{{ rowData.business_order_amount }}</span>
                    </div>
                </div>
                <div class="baseInfoBlock">
                    <div class="block_item">
                        <span class="label">{{ $t('approval.customerNumber') }}</span>
                        <span class="value">{{ rowData.customer_number }}</span>
                    </div>
                    <div class="block_item">
                        <span class="label">{{ $t('approval.quantity') }}</span>
                        <span class="value">{{ rowData.business_order_bike_quantity }}</span>
                    </div>
                </div>
            </div>

            <!-- 审核-表单信息 -->
            <div class="form" v-if="!showContentRightDetail">
                <!-- 财务审核 -->
                <div v-if="rowData.node_code_val === 'RISK_DELIVERY_FINANCE'">
                    <Form :form="form1" style="margin-top:10px"></Form>
                
                    <div class="form_title2">{{ $t('approval.overdueStatus') }}</div>

                    <Form 
                        :form="form2" 
                        style="margin-top:10px" 
                        @handleUploadSuccess="handleUploadSuccess"
                        @handleUploadError="handleUploadError"
                    >
                        <template #uploadFileType>
                            <span style="color: #999;">{{ $t('approval.fileType') }}</span>  
                        </template>
                    </Form>
                </div>
                <!-- 销售经理审核 -->
                <div v-if="rowData.node_code_val === 'RISK_DELIVERY_SALE'">
                    <div class="detail"> 
                        <div class="detail_item" v-for="(item,index) in detail" :key="index">
                            <div v-if="item.type == 'file'" class="detail_item_block">
                                <div class="label">{{ $t(item.label) }}</div>
                                <a class="downloadFile" @click="download(item.value, item.name)">{{ item.name }}</a>
                            </div>
                            <div v-else-if="item.label == 'approval.sale_instruction'" class="detail_item_block">
                                <!-- <div class="label">{{ $t(item.label) }}</div>
                                <a class="downloadFile" @click="download(item.value, item.name)">{{ item.name }}</a> -->
                            </div>
                            <div v-else class="detail_item_block">
                                <div class="label">{{ $t(item.label) }}</div>
                                <div class="value">{{ item.value }}</div>
                            </div>
                        </div>
                    </div>
                    
                    <Form 
                        :form="form3" 
                        style="margin-top:10px" 
                        @handleUploadSuccess="handleUploadSuccess"
                        @handleUploadError="handleUploadError"
                    >
                        <template #uploadFileType>
                            <span style="color: #999;">{{ $t('approval.fileType') }}</span>  
                        </template>
                    </Form>
                </div>
                <!-- CEO审核 -->
                <div class="detail" v-if="rowData.node_code_val === 'RISK_DELIVERY_CEO'">
                    <div class="detail_item" v-for="(item,index) in detail" :key="index">
                        <div v-if="item.type == 'file'" class="detail_item_block">
                            <div class="label">{{ $t(item.label) }}</div>
                            <a class="downloadFile" @click="download(item.value, item.name)">{{ item.name }}</a>
                        </div>
                        <div v-else class="detail_item_block">
                            <div class="label">{{ $t(item.label) }}</div>
                            <div class="value">{{ item.value }}</div>
                        </div>
                    </div>
                </div>
            </div>

            <!-- 审核详情 -->
            <div v-if="showContentRightDetail">
                <!-- 表单信息 -->
                <div  class="detail">
                    <div class="detail_item" v-for="(item,index) in detail" :key="index">
                        <div v-if="item.type == 'file'" class="detail_item_block">
                            <div class="label">{{ $t(item.label) }}</div>
                            <a class="downloadFile" @click="download(item.value, item.name)">{{ item.name }}</a>
                        </div>
                        <div v-else class="detail_item_block">
                            <div class="label">{{ $t(item.label) }}</div>
                            <div class="value">{{ item.value }}</div>
                        </div>
                    </div>
                </div>
                
                <!-- 审核记录 -->
                <div v-if="showContentRightDetail" class="form_title2" style="margin:15px 0">{{ $t('approval.approvalRecord') }}</div>
                <Table 
                    v-if="showContentRightDetail"
                    ref="recordTableRef"
                    class="record" 
                    :table="recordTable"
                >
                    <!-- 自定义字段 -->
                    <template v-slot:columns="{ props }">
                        <div v-if="props.column.key == 'status'" style="font-size:12px;">
                            <a-tag 
                                v-if="props.record.status != '-'"
                                :color="instanceStatusColor[props.record.status_val]" 
                                :text="props.record.status"
                            >{{ props.record.status }}</a-tag>
                            <div v-else>-</div>
                        </div>
                    </template>
                </Table>
            </div>
        </div>
    </div>  
</template>

<script setup>
    import { nextTick, onMounted, reactive, ref, watch, toRefs, h, computed } from 'vue';
    import { ApprovalApi } from '@/api/ApprovalApi.js';
    import { Form1, Form2, Form3 } from './queryConfig/ApprovalQuery.js';
    import { Message, Modal, Notification } from '@arco-design/web-vue';
    import { useRouter } from 'vue-router';
    import Table from '@/components/Table.vue';
    import Form from '@/components/Form.vue';
     
    import { dateToTimestamp, timestampToDate, formatterToPoint, formatterToComma, getNowDate, getWeek } from '@/utils/index.js';
    import { useI18n } from 'vue-i18n';
    import { useLocale } from '@/store/index.js';
    import { multiply, add, subtract, divide } from 'accurate-core';
    import { IconSearch } from '@arco-design/web-vue/es/icon';

    const router = useRouter()
    const localeStore = useLocale()
    const { t } = useI18n()

    const orderTableRef = ref(null)
    const userInfo = ref({})
    const activeKey = ref('1')
    const rowData = ref(null)
    const customer_name = ref('')
    const form1 = reactive(Form1)
    const form2 = reactive(Form2)
    const form3 = reactive(Form3)
    const showContentRight = ref(false)
    const showContentRightDetail = ref(false)
    const detail = ref([])
    const instanceStatusColor = reactive({
        1:'blue',//审批中
        2:'red',//拒绝
        3:'green',//审批通过
        4:'gray',//关闭
        6:'lime',//完成
    })
    const instanceStatus= reactive({
        1:t('approval.pending'),
        2:t('approval.rejected'),
        3:t('approval.approval'),
        4:t('approval.closed'),
        6:t('approval.finish'),
    })

    // 审批表格
    const table = ref({
        datas:[],
        columns:[
            {
                // title: '序号',
                title:'#',
                dataIndex: 'serial',
                key:'serial',
                width:'70',
                align:'left',
                fixed:'left',
            },
            {
                // title: '客户名称',
                title:t('approval.customerName'),
                dataIndex: 'customer_name',
                key:'customer_name',
                width:'140',
                align:'left',
                fixed:'left',
                filterable: {
                    filter: (value, record) => record.customer_name.includes(value),
                    slotName: 'searchFilter',
                    icon: () => h(IconSearch)
                }
            },
            {
                // title: '客户编号',
                title:t('approval.customerNumber'),
                dataIndex: 'customer_number',
                key:'customer_number',
                width:'130',
                align:'left',
            },
            {
                // title: '订单号',
                title:t('approval.orderNumber'),
                dataIndex: 'business_order_name',
                key:'business_order_name',
                width:'120',
                align:'left',
                filterable: {
                    filter: (value, record) => record.business_order_name.includes(value),
                    slotName: 'searchFilter',
                    icon: () => h(IconSearch)
                }
            },
            {
                // title: '流水号',
                title:t('approval.instanceCode'),
                dataIndex: 'instance_code',
                key:'instance_code',
                width:'150',
                align:'left',
                ellipsis:true,
                tooltip:true,
            },
            {
                // title: '订单金额',
                title:t('approval.orderAmount'),
                dataIndex: 'business_order_amount',
                key:'business_order_amount',
                width:'130',
                align:'left',
            },
            {
                // title: '整车数量',
                title:t('approval.quantity'),
                dataIndex: 'business_order_bike_quantity',
                key:'business_order_bike_quantity',
                width:'140',
                align:'left',
                ellipsis:true,
                tooltip:true,
            },
            {
                // title: '审批状态',
                title:t('approval.status'),
                dataIndex: 'instance_status',
                key:'instance_status',
                width:'110',
                align:'left',
                ellipsis:true,
                tooltip:true,
                slotName:'slot',
                filterable: {
                    filters: [
                        {
                            text: t('approval.pending'),
                            value: t('approval.pending'),
                        }, 
                    ],
                    filter: (value, row) => row.instance_status.includes(value),
                }
            },
            {
                // title: '当前审批节点',
                title:t('approval.currentNodeCode'),
                dataIndex: 'node_code',
                key:'node_code',
                width:'160',
                align:'left',
                ellipsis:true,
                tooltip:true,
                // slotName:'slot',
            },
            {
                // title: '发起日期',
                title:t('approval.initiationDate'),
                dataIndex: 'create_timestamp',
                key:'create_timestamp',
                width:'130',
                align:'left',
                ellipsis:true,
                tooltip:true,
            },
            {
                title: t('base.operate'),
                dataIndex: 'Optional',
                key:'Optional',
                slotName:'optional',
                width: '100',
                align:'center',
                fixed:'right'
            }
        ],
        configs:{
            scroll:{
                x:1000,
                y: 670
            },
            stripe:true,
            bordered:true,
            size:'large',
            loading:false,
            expandable:'',
            expand:false,
            pagination:false,
        },
    })

    // 审批表格
    const recordTable = ref({
        datas:[],
        columns:[
            {
                // title: '审批节点',
                title:t('approval.nodeCode'),
                dataIndex: 'node_code',
                key:'node_code',
                width:'160',
                align:'left',
                fixed:'left',
            },
            {
                // title: '审批人',
                title:t('approval.userName'),
                dataIndex: 'user_name',
                key:'user_name',
                width:'90',
                align:'left',
            },
            {
                // title: '事件审批状态',
                title:t('approval.statusRes'),
                dataIndex: 'status',
                key:'status',
                width:'90',
                align:'left',
                slotName:'slot',
            },
            {
                // title: '审批开始日期',
                title:t('approval.beginDate'),
                dataIndex: 'begin_date',
                key:'begin_date',
                width:'140',
                align:'left',
                ellipsis:true,
                tooltip:true,
            },
            {
                // title: '审批结束日期',
                title:t('approval.endDate'),
                dataIndex: 'end_date',
                key:'end_date',
                width:'140',
                align:'left',
                ellipsis:true,
                tooltip:true,
            },
        ],
        configs:{
            scroll:{
                // x:1000,
                y: 350
            },
            stripe:true,
            bordered:false,
            size:'large',
            loading:false,
            expandable:'',
            expand:false,
            pagination:false,
        },
    })

    // 切换tab
    const tabClick = (val)=>{
        activeKey.value = val
        getApprovalList()
        deleteFilters()

        let item = table.value.columns.find(i=> i.key == 'instance_status')
        item.filterable.filters = []
        if(val == 1){
            item.filterable.filters.push({
                text: t('approval.pending'),
                value: t('approval.pending'),
            })
        }else{
            item.filterable.filters.push(
                {
                    text: t('approval.approval'),
                    value: t('approval.approval'),
                }, 
                {
                    text: t('approval.rejected'),
                    value: t('approval.rejected'),
                }, 
                {
                    text: t('approval.closed'),
                    value: t('approval.closed'),
                }
            )
        }
        
    }

    // 清除筛选
    const deleteFilters = ()=>{
        orderTableRef.value.resetFilter()
    }

    // 按钮禁用
    const getDisabled = (status,type)=>{
        return status != 2 && status != 3 && status != 4
    }

    // 金额千分位格式化
    const toThousands = (val)=> { // type: 'de-DE'--德国计数法  'zh-ZH'--中国计数法  'fr-FR'--法国计数法
        return new Intl.NumberFormat('de-DE').format(val)
    }

    // 下载文件
    const download = (url,name)=>{
        Notification.success(t('approval.downloading'))
        let xhr = new XMLHttpRequest();
        xhr.open('GET',url,true)
        xhr.responseType = 'blob'
        xhr.onload = ()=>{
            let url = window.URL.createObjectURL(xhr.response)
            let a = document.createElement('a')
            a.href = url
            a.download = name
            a.click()
        }
        xhr.send();    
    }

    const handle = (type, row)=>{
        switch(type){
            case 'approval':
                showContentRight.value = true
                showContentRightDetail.value = false
                rowData.value = row
                getApprovalForm(row)
                break;
            case 'detail':
                showContentRight.value = true
                showContentRightDetail.value = true
                rowData.value = row
                getApprovalDetail(row)
                approvalRecord(row)
                break;
            case 'refuse':
                Modal.confirm({
                    title: t('base.tip'),
                    titleAlign:'start',
                    width:350,
                    content: t('approval.refuseTip'),
                    okText:t('base.ok'),
                    cancelText:t('base.cancel'),
                    onOk:()=>{
                        refuseApproval(rowData.value)
                    }
                })
                break;
            case 'close':
                Modal.confirm({
                    title: t('base.tip'),
                    titleAlign:'start',
                    width:350,
                    content: t('approval.closeTip'),
                    okText:t('base.ok'),
                    cancelText:t('base.cancel'),
                    onOk:()=>{
                        closeApproval(row)
                    }
                })
                break;
            case 'cancel': // 取消
                showContentRight.value = false
                break;
            case 'adopt': // 审批通过
                let form = {}
                // 财务
                if(rowData.value.node_code_val === 'RISK_DELIVERY_FINANCE'){
                    form = { ...form1.formData, ...form2.formData }

                    for(let key in form){
                        if(form[key] === ''){
                            Message.error(t(`approval.${key}`) + ' ' + t('base.noEmpty'))
                            return
                        }
                    }
                }
                // 销售经理
                if(rowData.value.node_code_val === 'RISK_DELIVERY_SALE'){
                    form = { ...form3.formData}
                }

                Modal.confirm({
                    title: t('base.tip'),
                    titleAlign:'start',
                    width:350,
                    content: t('approval.approveTip'),
                    okText:t('base.ok'),
                    cancelText:t('base.cancel'),
                    onOk:()=>{
                        adoptApproval(form)
                    }
                })
                break;
        }
    }

    // 上传文件成功
    const handleUploadSuccess = (file)=>{
        console.log(file,'file',file.response.data)
        form2.formData.credit_file = file.response.data
        form2.formData.credit_file_name = file.name
    }

    // 上传文件失败
    const handleUploadError = (file)=>{
        console.log(file,'error')
    }

    // 获取列表
    const getApprovalList = async()=>{
        let param = {
            active_flag: 1
        }

        // 4:财务 10: 销售助理  11：CEO  12：销售经理
        let arr = userInfo.value.role.split(',')
        if((arr.includes('4') || arr.includes('10') || arr.includes('11') || arr.includes('12')) && activeKey.value == '1') param.user_id = userInfo.value.id
        if(activeKey.value == '1'){
            param.status = 1 
            param.instance_status = 1
        } 
        if(activeKey.value == '2') param.status = 6

        table.value.configs.loading = true
        let res = await ApprovalApi.getInstance().getApprovalList(param)
        if(res.code == 0){
            res.data.length > 0 && res.data.forEach((item,index)=>{
                item.serial = index + 1
                item.business_order_amount = `${toThousands(item.business_order_amount)} €`
                item.instance_status_val = item.instance_status
                item.instance_status = item.instance_status == undefined? '-' : instanceStatus[item.instance_status]
                item.create_timestamp = item.create_timestamp == undefined? '-' : timestampToDate(item.create_timestamp * 1000)
                item.node_code_val = item.node_code
                item.node_code = item.node_code == 'RISK_DELIVERY_FINANCE'? t('approval.finance') : item.node_code == 'RISK_DELIVERY_CEO'? t('approval.ceo') : item.node_code == 'RISK_DELIVERY_SALE'? t('approval.sale') : '-'
            })
            table.value.datas = res.data
            table.value.configs.loading = false
        }else{
            Message.error(res.msg)
        }
    }

    // 获取表单字段
    const getApprovalForm = async(row)=>{
        let param = {
            instance_code: row.instance_code,
            type:2, // 2: 审批
        }

        let res = await ApprovalApi.getInstance().getApprovalForm(param)
        if(res.code == 0){
            // 财务可编辑的表单字段
            if(row.node_code_val === 'RISK_DELIVERY_FINANCE'){
                form1.formField = []
                form2.formField = []
                res.data.node_form.forEach(item=>{
                    if(item.form_key == 'history_amount'){
                        form1.formField.push({
                            name:`approval.${item.form_key}`, 
                            key:item.form_key,
                            type:item.form_web_type,   
                            allowClear:true,
                            required:true,
                            hideButton:item.form_web_type == 'inputNumber',
                            suffix:item.form_web_type == 'inputNumber',
                            suffixText:'€',
                            width:'100%',
                        })  
                    }
                    if(item.form_key != 'history_amount' && item.form_key != 'credit_file_name'){
                        form2.formField.push({
                            name:`approval.${item.form_key}`, 
                            key:item.form_key,
                            type:item.form_web_type,   
                            allowClear:true,
                            required:true,
                            hideButton:item.form_web_type == 'inputNumber',
                            suffix:item.form_web_type == 'inputNumber',
                            suffixText:item.form_key == 'customer_unpaid_amount'? '€' : item.form_key == 'maximum_overdue_days'? 'Days' : '',
                            width:'100%',
                            min: item.form_key == 'maximum_overdue_days'? 0 : ''
                        }) 
                    }
                })

                let item = form2.formField.find(i=> i.key == 'customer_payment')
                item.optionToLocale = true
                item.options = [{
                    label:'SEPA',
                    value:'1',
                },
                {
                    label:'By invoice',
                    value:'2',
                }]

                let item2 = form2.formField.find(i=> i.key == 'credit_file')
                item2.fileList = []
                item2.limit = 1

                form1.formField.forEach(item=>{
                    form1.formData[item.key] = ''
                })
                form2.formField.forEach(item=>{
                    if(item.key == 'customer_unpaid_amount'){
                        form2.formData[item.key] = res.data.customer_unpaid_amount
                    }else{
                        form2.formData[item.key] = ''
                    }
                })
            }

            // 销售经理可见字段
            if(row.node_code_val === 'RISK_DELIVERY_SALE'){
                setDetail(res.data)
                form3.formField = []
                res.data.node_form.forEach(item=>{
                    if(item.form_key == 'sale_instruction'){
                        form3.formField.push({
                            name:`approval.${item.form_key}`, 
                            key:item.form_key,
                            type:'textarea',   
                            allowClear:true,
                            required:item.required_flag,
                            width:'100%',
                        })  
                    }
                })

                form3.formField.forEach(item=>{
                    form3.formData[item.key] = ''
                })
            }
            
            // CEO可见字段
            if(row.node_code_val === 'RISK_DELIVERY_CEO'){
                setDetail(res.data)
            }
        }else{
            Message.error(res.msg)
        }
    }

    // 获取审批详情
    const getApprovalDetail = async(row)=>{
        let param = {
            instance_code: row.instance_code,
            type:1, // 1: 详情
        }
        let res = await ApprovalApi.getInstance().getApprovalForm(param)
        if(res.code == 0){
            setDetail(res.data)
        }else{
            Message.error(res.msg)
        }
    }

    // 设置详情字段
    const setDetail = (data)=>{
        detail.value = []
        let arr = ['credit_file','credit_file_name','business_order_name','customer_name','customer_number','business_order_amount','business_order_bike_quantity']
        data.read_node_form.forEach(item=>{
            if(item.form_key == 'customer_payment'){
                detail.value.push({
                    label: `approval.${item.form_key}`,
                    value: data[item.form_key] == undefined? '-' : data[item.form_key] == 1? 'SEPA' : 'By invoice',
                    type:'text',
                })
            }else if(item.form_key == 'credit_file'){
                detail.value.push({
                    label: `approval.${item.form_key}2`,
                    value: data[item.form_key] == undefined? '-' :data[item.form_key],
                    type: 'file',
                    name: data.credit_file_name == undefined? '-' : data.credit_file_name,
                })
            }else if(!arr.includes(item.form_key)){
                detail.value.push({
                    label: `approval.${item.form_key}`,
                    value: data[item.form_key] == undefined? '-' : item.form_key == 'history_amount' || item.form_key == 'customer_unpaid_amount'? `${toThousands(data[item.form_key])} €` : data[item.form_key],
                    type: 'text',
                })
            }
        })
        console.log(detail.value,'detail')
    }

    // 审批记录
    const approvalRecord = async(row)=>{
        let param = {
            instance_code:row.instance_code
        }
        recordTable.value.configs.loading = true
        let res = await ApprovalApi.getInstance().getApprovalRecord(param)
        if(res.code == 0){
            recordTable.value.datas = []
            res.data.length > 0 && res.data.forEach(i=>{
                recordTable.value.datas.push({
                    ...i,
                    node_code: i.node_code == 'RISK_DELIVERY_BEGIN'? t('approval.nodeBegin') : i.node_code == 'RISK_DELIVERY_FINANCE'? t('approval.nodeFinance') : i.node_code == 'RISK_DELIVERY_SALE'? t('approval.nodeSale') : i.node_code == 'RISK_DELIVERY_CEO'? t('approval.nodeCEO') : t('approval.nodeEnd'),
                    status_val: i.status,
                    status:i.status == undefined? '-' : instanceStatus[i.status],
                    begin_date: i.begin_date == undefined? '-' : timestampToDate(i.begin_date * 1000),
                    end_date: i.end_date == undefined? '-' : timestampToDate(i.end_date * 1000),
                })
            })
            recordTable.value.configs.loading = false
        }else{
            Message.error(res.msg)
        }
    }

    // 审批-通过
    const adoptApproval = async(form)=>{
        table.value.configs.loading = true
        let res = await ApprovalApi.getInstance().passApproval(form, rowData.value.instance_code, rowData.value.transaction_code )
        if(res.code == 0){
            Message.success(t('approval.approvalSuccess'))
            showContentRight.value = false
            table.value.configs.loading = false
            getApprovalList()
        }else{
            Message.error(res.msg)
        }
    }

    // 审批-拒绝
    const refuseApproval = async(row)=>{
        console.log(row,'row')
        table.value.configs.loading = true
        let res = await ApprovalApi.getInstance().refuseApproval(row.instance_code)
        if(res.code == 0){
            Message.success(t('approval.approvalRefuse'))
            showContentRight.value = false
            table.value.configs.loading = false
            getApprovalList()
            
        }else{
            Message.error(res.msg)
        }
    }

    // 审批-关闭
    const closeApproval = async(row)=>{
        table.value.configs.loading = true
        let res = await ApprovalApi.getInstance().closeApproval(row.instance_code)
        if(res.code == 0){
            Message.success(t('approval.approvalClose'))
            table.value.configs.loading = false
            getApprovalList()
        }else{
            Message.error(res.msg)
        }
    }

    onMounted(()=>{
        if(sessionStorage.getItem('userInfo')){
            userInfo.value = JSON.parse(sessionStorage.getItem('userInfo'))
        }

        getApprovalList()

        sessionStorage.removeItem('toPage')
    })

</script>

<style lang="less" scoped>
.approval_container{
    display: flex;

    .content_left{
        display: flex;
        flex: 1;
        flex-direction: column;
        width:700px;
        
        .content_left_header{
            display: inline-block;
            padding:0 20px 0 0;
            font-size: 25px;

            /deep/ .arco-tabs-content{
                padding-top:6px;
            }
        }

        .deleteFilters{
            float: right;
            margin-top: -43px;
        }

        // .searchFilter{
        //     padding: 20px;
        //     background: #fff;
        //     box-shadow: 0px 5px 15px 0px rgba(0, 0, 0, 0.12), 0px 15px 35px 0px rgba(60, 66, 87, 0.08);
        // }
    }

    .content_right{
        display: flex;
        flex: 1;
        flex-direction: column;
        margin-top: 8px;
        margin-left: 15px;
        padding: 15px 20px;
        // width:400px;
        background: #fff;
        border-radius: 4px;

        .content_right_hd{
            display: flex;

            .form_title{
                display:flex;
                flex:1;
                margin: 0 0 10px;
                font-size: 18px;
                font-weight: bold;
            }

            .footerBtn{
                display: flex;
                flex: 1;
                justify-content: flex-end;
                margin-bottom:10px;

                .adopt{
                    margin-right:10px;
                }
            }
        }
       
        .baseInfo{
            display: flex;
            padding:10px;
            background: #F2F2F2;
            border-radius:5px;
            font-size: 11px;

            .baseInfoBlock{
                display: flex;
                flex: 1;
                flex-direction: column;
                padding: 0 10px 0 0;
                border-right: 1px dashed #ccc;

                .block_item{
                    display:flex;
                    
                    .label{
                        display: flex;
                        flex: 1;
                        max-width: 120px;
                    }
                    .value{
                        display: flex;
                        flex: 2;
                        justify-content: flex-end;
                        align-items: flex-end;
                        font-weight: 600;
                        word-break: break-all;
                    }
                }
            }

            .baseInfoBlock:nth-last-child(1){
                border-right: none;
                padding: 0 0 0 10px;
            }
        }

        .form_title2{
            margin:0;
            font-size: 20px;
            font-weight: bold;
        }
        
        .form{
            .form_label{
                margin-bottom: 5px;
                font-size: 15px;
            }
            .require{
                color: red;
            
            }

            .form_item{
                margin: 10px 0 0 0;

                .fileType{
                    color: #3F3F3F;
                }
            }

            .form_item2{
                display: flex;

                .form_item_right{
                    display: flex;
                    flex: 1;
                    flex-direction: column;
                    margin-right: 10px;
                }
                .form_item_left{
                    display: flex;
                    flex: 1;
                    flex-direction: column;
                }
            }
        }

        .detail{
            margin-top:15px;
            padding: 20px 15px;
            border-radius: 6px;
            font-size:14px;
            background: #F2F2F2;

            .detail_item_block{
                display: flex;
                padding: 3px 0;

                .label{
                    display: flex;
                    flex: 1;
                }

                .value{
                    display: flex;
                    flex: 1;
                    align-items: flex-end;
                    justify-content: flex-end;
                    font-weight: 600;
                    word-break: break-all;
                }

                .downloadFile{
                    color: #1890ff;
                    font-weight: 600;
                    cursor: pointer;
                }
            }
        }
    }
}

.searchFilter{
    padding: 20px;
    background: #fff;
    box-shadow: 0px 5px 15px 0px rgba(0, 0, 0, 0.12), 0px 15px 35px 0px rgba(60, 66, 87, 0.08);
}

/deep/ .arco-table-th{
    background: #fff;
    border-bottom: 1px solid #eee;
    border-right: 1px solid #eee;
    // padding: 0px 0;
    font-size: 13px;
    font-weight: 600;
}

/deep/ .arco-table-td{
    padding: 0;
    // border-bottom: none;
    border-right: 1px solid #eee;
}

/deep/ .arco-table-container{
    padding-bottom:0;
}

/deep/ .table_pagination{
    display:none;
}

/deep/  button:focus,
/deep/  button:focus-visible{
    outline: none;
}

/deep/ .arco-upload-wrapper{
    display: inline-block;
    margin-right:20px;
    width: auto;
}

/deep/ .arco-form-item{
    margin-bottom: 10px;
}

/deep/ .arco-btn-size-mini{
    height: 20px;
    margin: 0 2px;
    padding: 0 3px;
    font-size: 11px;
}
</style>